export const CONTACT_CARD_ENTER_DELAY = 1000;
export const CONTACT_PICKER_CLASS = "sds-contact-picker";
